import React, { useEffect, useState } from "react";
import PlaceOrdersService from "../services/PlaceOrderService";
import { Button } from "@headlessui/react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "./Pagination";
import DataTable from "react-data-table-component";

import PieCharts from "./PieChart";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Sector,
  Cell,
} from "recharts";

function DashBoard() {
  const location = useLocation();
  const getpageid = location.search.split("=")[1]
    ? location.search.split("=")[1]
    : 1;
  const [orders, setOrders] = useState([]);
  const [paginatelinks, setPaginatelinks] = useState([]);
  const [paginatemeta, setPaginatemeta] = useState([]);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  useEffect(() => {
    retrieveOrders();
  }, [getpageid]);

  const retrieveOrders = () => {
    PlaceOrdersService.getAll(getpageid)
      .then((response) => {
        // console.log("User Orders:" + JSON.stringify(response.data));
        setOrders(response.data.data);
        setDatatable(response.data.data);
        setPaginatelinks(response.data.links);
        setPaginatemeta(response.data.meta);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  // console.log("Orders: " + JSON.stringify(datatable));

  // React Data Table
  const columns = [
    {
      name: "Order",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.created_at.split("T")[0],
      sortable: true,
    },

    {
      name: "Payment Method",
      selector: (row) => row.paymentmethod,
      sortable: true,
    },

    {
      name: "Amount",
      selector: (row) => parseInt(row.totalprice),
      sortable: true,
    },
    {
      name: "Paid",
      selector: (row) => (row.ispaid == 1 ? "Paid" : "Unpaid"),
      sortable: true,
    },
    {
      name: "Picked",
      selector: (row) => (row.isdelivered == 1 ? "Picked" : "UnPicked"),
      sortable: true,
    },
  ];

  const [datatable, setDatatable] = useState([]);

  const data = [
    {
      name: "Page A",
      uv: 4000,
      pv: 2400,
    },
    {
      name: "Page B",
      uv: 3000,
      pv: 1398,
    },
    {
      name: "Page C",
      uv: 2000,
      pv: 9800,
    },
    {
      name: "Page D",
      uv: 2780,
      pv: 3908,
    },
    {
      name: "Page E",
      uv: 1890,
      pv: 4800,
    },
    {
      name: "Page F",
      uv: 2390,
      pv: 3800,
    },
    {
      name: "Page G",
      uv: 3490,
      pv: 4300,
    },
  ];

  // console.log("Orders: " + JSON.stringify(datatable));

  return (
    <div className="container m-12">
      <div className="text-3xl py-7">
        {" "}
        {user.name}! Your Sample Order DashBoard
      </div>
      {/* <table className="w-full">
        <thead>
          <tr>
            <th className="border border-gray-300 dark:border-gray-600 p-3">
              #Order
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3 sm:w-40">
              Date
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3">
              Payment Method
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3">
              Amount
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3">
              Paid
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3">
              Picked Up
            </th>
            <th className="border border-gray-300 dark:border-gray-600 p-3"></th>
          </tr>
        </thead>
        <tbody>
          {orders &&
            orders.map((item, k) => (
              <tr key={k}>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.id}
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.created_at.split("T")[0]}
                  <br />
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.paymentmethod}
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.totalprice}
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.ispaid == 1 ? (
                    <span className="bg-green-700 text-white p-3 rounded">
                      Paid
                    </span>
                  ) : (
                    <span className="bg-red-300 text-black p-3 rounded">
                      Unpaid
                    </span>
                  )}
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  {item.isdelivered == 1 ? (
                    <span className="bg-green-700 text-white p-3 rounded">
                      Picked
                    </span>
                  ) : (
                    <span className="bg-yellow-300 text-black p-3 rounded">
                      UnPicked
                    </span>
                  )}
                </td>
                <td className="border border-gray-300 dark:border-gray-600 p-3">
                  <Button
                    onClick={() => {
                      navigate("/checkout/order/" + item.id);
                    }}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Order Details
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {orders && (
        <Pagination pagination={{ links: paginatelinks, meta: paginatemeta }} />
      )} */}

      {/* Bar Chart */}
      <BarChart
        width={730}
        height={250}
        data={data}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="pv"
          fill="#8884d8"
        />
        <Bar
          dataKey="uv"
          fill="#82ca9d"
        />
      </BarChart>
      <h1 className="text-xl">Bar charts for sales by category</h1>

      <hr></hr>

      {/* <LineChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="pv"
          stroke="#8884d8"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="uv"
          stroke="#82ca9d"
        />
      </LineChart>

      <h1 className="text-xl">Line graphs for monthly trends.</h1>
      <PieCharts />
      <h1 className="text-xl">Pie charts for revenue distribution.</h1>

      <DataTable
        columns={columns}
        data={datatable}
        direction="auto"
        fixedHeader
        // fixedHeaderScrollHeight="400px"
        pagination
        responsive
        subHeaderAlign="right"
        subHeaderWrap
        className="bg-primary"
      /> */}

      <br></br>
      <br></br>
      {/* {orders && (
        <Pagination pagination={{ links: paginatelinks, meta: paginatemeta }} />
      )} */}
    </div>
  );
}

export default DashBoard;
